import React from 'react';

type Option = { label: string; value: string };

export function RadioGroup({
                               name, value, options, onChange, indicatorStyle
                           }: {
    name: string;
    value: string | number | boolean;
    options: Option[];
    onChange: (v: string)=>void;
    indicatorStyle?: React.CSSProperties;
}) {
    return (
        <div style={{marginLeft: 13}}>
            {options.map((o, i) => (
                <label className="price_radio_label" key={i}>
                    <input
                        type="radio"
                        name={name}
                        value={o.value}
                        checked={String(value) === o.value}
                        onChange={e => onChange(e.target.value)}
                        className="price_radio"
                    />
                    <div className="price_radio_indicator" style={indicatorStyle}/>
                    {o.label}
                </label>
            ))}
        </div>
    );
}
